import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageLayout from "../layout/page-layout";
import { usePPA } from "context/ppa-context";
import { getTopLevelNavigationCardItems } from "lib/utils";
import NavigationCards from "components/navigation/navigation-cards/navigation-cards";
import NavigationCards2 from "components/navigation/navigation-cards/navigation-cards2";


export default function Index() {
  const { hasAccess, isSignupComplete } = usePPA();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasAccess && !isSignupComplete) {
      console.log(`Index -> incomplete signup ->`);
      navigate(`/signup`);
    }
  }, [hasAccess, isSignupComplete]);

  return (
    <PageLayout>
      <NavigationCards2 topLevel />
    </PageLayout >
  );
}